import React from 'react';
import { Box } from '@mui/material';
import { bookingStatusConfig } from '../../utils/bookingStatus';
import { SCHED } from './scheduleTheme';

interface BookingStatusPillProps {
  status: string;
  /** When given, the pill is a button (opens the shared status dialog). */
  onClick?: () => void;
}

// Text 30% darker than the status colour so it stays readable (≥ 4.5:1) on the tinted fill.
const darken = (hex: string) => {
  const n = parseInt(hex.slice(1), 16);
  const ch = (shift: number) => Math.round(((n >> shift) & 255) * 0.7).toString(16).padStart(2, '0');
  return `#${ch(16)}${ch(8)}${ch(0)}`;
};

/** A booking's status in the panel's shared status colours, as a pill. */
const BookingStatusPill: React.FC<BookingStatusPillProps> = ({ status, onClick }) => {
  const { label, color, solid } = bookingStatusConfig(status);
  return (
    <Box
      component={onClick ? 'button' : 'span'}
      {...(onClick ? { type: 'button', onClick, 'aria-label': `${label}, change status` } : {})}
      sx={{
        flexShrink: 0,
        fontFamily: SCHED.font,
        fontSize: '13px',
        fontWeight: 700,
        lineHeight: 1,
        p: '9px 14px',
        borderRadius: '999px',
        border: `1px solid ${solid ? color : `${color}59`}`,
        backgroundColor: solid ? color : `${color}2E`,
        color: solid ? '#FFFFFF' : darken(color),
        whiteSpace: 'nowrap',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'background-color 0.15s',
        ...(onClick
          ? { '&:hover': { backgroundColor: solid ? darken(color) : `${color}40` }, '&:focus-visible': { outline: `2px solid ${color}`, outlineOffset: 2 } }
          : {}),
      }}
    >
      {label}
    </Box>
  );
};

export default BookingStatusPill;
